export const getHistory = (state) => {
  return state.payments.withdrawalHistory.items;
};
export const getHistoryTotal = (state) => state.payments.withdrawalHistory.totalNumber;
